import type { PresentationOptionV2, QuoteFile } from 'paintscout'
import { replaceSectionImages } from './replaceSectionImages'

/**
 * Swaps a presentation's placeholder images for the company's own, walking the v2 tree
 * (`pages → sections → blocks`) and handing each block to replaceSectionImages.
 *
 * Images are consumed in order and looped once exhausted, so a company with three photos still
 * fills a layout with twenty image slots.
 */
export function replacePresentationImages(args: {
  presentation: PresentationOptionV2
  images: QuoteFile[]
}): PresentationOptionV2 {
  const { presentation, images } = args
  let usedCount = 0
  let loopedImages = [...images]

  presentation.pages.forEach((page, pageIndex) => {
    page.sections.forEach((section, sectionIndex) => {
      section.blocks.forEach((block, blockIndex) => {
        // loop images if close to end
        // probably max 6 images per block
        while (usedCount + 6 >= loopedImages.length) {
          loopedImages = [...loopedImages, ...images]
        }

        const { section: newBlock, imageCount } = replaceSectionImages({
          section: block,
          images: loopedImages.slice(usedCount)
        })

        presentation.pages[pageIndex].sections[sectionIndex].blocks[blockIndex] = newBlock
        usedCount += imageCount
      })
    })
  })

  return presentation
}
